export const normalizeScanDetails = (data, screenLabels) => {
  return [
    {
      category: "Wellness",
      metrics: [
        {
          key: "wellness",
          label: screenLabels?.wellness_score?.label_value || "Wellness Score",
          value: data.body?.wellness_score,
          avg: "",
          unit: "/10",
          status: data.body?.wellness_level,
          comment: data.body?.wellness_comment || "",
        },
      ],
    },
    {
      category: "Body",
      metrics: [
        {
          key: "body_mass_index",
          label:
            screenLabels?.body_mass_index_comment?.label_value ||
            "Body Mass Index",
          value: data.body?.body_mass_index,
          avg: data.body?.body_mass_index_avg,
          normal: data.body?.body_mass_index_normal,
          status: data.body?.body_mass_index_status,
        },
        {
          key: "physiological_strain_index_(psi)",
          label:
            screenLabels?.physiological_strain_index_comment?.label_value ||
            "Physiological Strain Index",
          value: data.body?.physiological_strain_index,
          avg: data.body?.physiological_strain_index_avg,
          normal: data.body?.physiological_strain_index_normal,
          status: data.body?.physiological_strain_index_status,
        },
        {
          key: "waist_to_height_ratio",
          label:
            screenLabels?.waist_to_height_ratio_comment?.label_value ||
            "Waist To Height Ratio",
          value: data.body?.waist_to_height_ratio,
          avg: data.body?.waist_to_height_ratio_avg,
          normal: data.body?.waist_to_height_ratio_normal,
          status: data.body?.waist_to_height_ratio_status,
        },
        {
          key: "body_shape_index",
          label:
            screenLabels?.body_shape_index_comment?.label_value ||
            "Body Shape Index",
          value: data.body?.body_shape_index,
          avg: data.body?.body_shape_index_avg,
          normal: data.body?.body_shape_index_normal,
          status: data.body?.body_shape_index_status,
        },
        {
          key: "fatigue_index",
          label:
            screenLabels?.fatigue_index_comment?.label_value || "Fatigue Index",
          value: data.body?.fatigue_index,
          avg: data.body?.fatigue_index_avg,
          normal: data.body?.fatigue_index_normal,
          status: data.body?.fatigue_index_avg_status,
        },
        {
          key: "inflammation_index",
          label:
            screenLabels?.inflammation_index_comment?.label_value ||
            "Inflammation Index",
          value: data.body?.inflammation_index,
          avg: data.body?.inflammation_index_avg,
          normal: data.body?.inflammation_index_normal,
          status: data.body?.inflammation_index_status,
        },
        {
          key: "metabolic_efficiency_ratio",
          label:
            screenLabels?.metabolic_efficiency_ratio_comment?.label_value ||
            "Metabolic Efficiency Ratio",
          value: data.body?.metabolic_efficiency_ratio,
          avg: data.body?.metabolic_efficiency_ratio_avg,
          normal: data.body?.metabolic_efficiency_ratio_normal,
          status: data.body?.metabolic_efficiency_ratio_status,
        },
        {
          key: "metabolic_health_score",
          label:
            screenLabels?.metabolic_health_score_comment?.label_value ||
            "Metabolic Health Score",
          value: data.body?.metabolic_health_score,
          avg: data.body?.metabolic_health_score_avg,
          normal: data.body?.metabolic_health_score_normal,
          status: data.body?.metabolic_health_score_status,
        },
      ],
    },
    {
      category: "Blood",
      metrics: [
        {
          key: "hemoglobin",
          label: screenLabels?.hemoglobin_comment?.label_value || "Hemoglobin",
          value: data.blood?.hemoglobin,
          avg: data.blood?.hemoglobin_avg,
          normal: data.blood?.hemoglobin_normal,
          status: data.blood?.hemoglobin_status,
        },
        {
          key: "hba1c",
          label: screenLabels?.hemoglobin_a1c_comment?.label_value || "HbA1c",
          value: data.blood?.hemoglobin_a1c,
          avg: data.blood?.hemoglobin_a1c_avg,
          normal: data.blood?.hemoglobin_a1c_normal,
          status: data.blood?.hemoglobin_a1c_status,
        },
        {
          key: "hemoglobin_score",
          label:
            screenLabels?.hemoglobin_score?.label_value || "Hemoglobin Score",
          value: data.blood?.hemoglobin_score,
          avg: data.blood?.hemoglobin_score_avg,
          normal: data.blood?.hemoglobin_score_normal,
          status: data.blood?.hemoglobin_score_status,
        },
        {
          key: "average_blood_glucose",
          label:
            screenLabels?.average_blood_glucose?.label_value ||
            "Average Blood Glucose",
          value: data.blood?.average_blood_glucose,
          avg: data.blood?.average_blood_glucose_avg,
          normal: data.blood?.average_blood_glucose_normal,
          status: data.blood?.average_blood_glucose_status,
        },
        {
          key: "anemia_index",
          label: screenLabels?.anemia_index?.label_value || "Anemia Index",
          value: data.blood?.anemia_index,
          avg: data.blood?.anemia_index_avg,
          normal: data.blood?.anemia_index_normal,
          status: data.blood?.anemia_index_status,
        },
        {
          key: "glucose_management_indicator",
          label:
            screenLabels?.glucose_management_indicator?.label_value ||
            "Glucose Management Indicator",
          value: data.blood?.glucose_management_indicator,
          avg: data.blood?.glucose_management_indicator_avg,
          normal: data.blood?.glucose_management_indicator_normal,
          status: data.blood?.glucose_management_indicator_status,
        },
      ],
    },
    {
      category: "Risks",
      metrics: [
        {
          key: "high_hba1c_risk",
          label:
            screenLabels?.high_hba1c_risk?.label_value || "High HbA1c Risk",
          value: data.risks?.high_hba1c_risk,
          avg: data.risks?.high_hba1c_risk_avg,
          normal: data.risks?.high_hba1c_risk_normal,
          status: data.risks?.high_hba1c_risk_status,
        },
        {
          key: "high_blood_pressure_risk",
          label:
            screenLabels?.high_blood_pressure_risk_comment?.label_value ||
            "High Blood Pressure Risk",
          value: data.risks?.high_blood_pressure_risk,
          avg: data.risks?.high_blood_pressure_risk_avg,
          normal: data.risks?.high_blood_pressure_risk_normal,
          status: data.risks?.high_blood_pressure_risk_status,
        },
        {
          key: "ascvd_risk",
          label: screenLabels?.ascvd_risk_comment?.label_value || "ASCVD Risk",
          value: data.risks?.ascvd_risk,
          avg: data.risks?.ascvd_risk_avg,
          normal: data.risks?.ascvd_risk_normal,
          status: data.risks?.ascvd_risk_status,
        },
        {
          key: "high_fasting_glucose_risk",
          label:
            screenLabels?.high_fasting_glucose_risk?.label_value ||
            "High Fasting Glucose Risk",
          value: data.risks?.high_fasting_glucose_risk,
          avg: data.risks?.high_fasting_glucose_risk_avg,
          normal: data.risks?.high_fasting_glucose_risk_normal,
          status: data.risks?.high_fasting_glucose_risk_status,
        },
        {
          key: "high_cholesterol_risk",
          label:
            screenLabels?.high_total_cholesterol_risk_comment?.label_value ||
            "High Total Cholesterol Risk",
          value: data.risks?.high_total_cholesterol_risk,
          avg: data.risks?.high_total_cholesterol_risk_avg,
          normal: data.risks?.high_total_cholesterol_risk_normal,
          status: data.risks?.high_total_cholesterol_risk_status,
        },
        {
          key: "hypertension_risk_score",
          label:
            screenLabels?.hypertension_risk_score?.label_value ||
            "Hypertension Risk",
          value: data.risks?.hypertension_risk_score,
          avg: data.risks?.hypertension_risk_score_avg,
          normal: data.risks?.hypertension_risk_score_normal,
          status: data.risks?.hypertension_risk_score_status,
        },
        {
          key: "low_hemoglobin_risk",
          label:
            screenLabels?.low_hemoglobin_risk_comment?.label_value ||
            "Low Hemoglobin Risk",
          value: data.risks?.low_hemoglobin_risk,
          avg: data.risks?.low_hemoglobin_risk_avg,
          normal: data.risks?.low_hemoglobin_risk_normal,
          status: data.risks?.low_hemoglobin_risk_status,
        },
        {
          key: "tuberculosis_risk",
          label:
            screenLabels?.tuberculosis_risk_comment?.label_value ||
            "Tuberculosis Risk",
          value: data.risks?.tuberculosis_risk,
          avg: data.risks?.tuberculosis_risk_avg,
          normal: data.risks?.tuberculosis_risk_normal,
          status: data.risks?.tuberculosis_risk_status,
        },
      ],
    },
    {
      category: "Stress",
      metrics: [
        {
          key: "stress_level",
          label:
            screenLabels?.stress_level_comment?.label_value || "Stress Level",
          value: data.stress?.stress_level,
          avg: data.stress?.stress_level_avg,
          normal: data.stress?.stress_level_normal,
          status: data.stress?.stress_level_status,
        },
        {
          key: "stress_index",
          label:
            screenLabels?.stress_index_comment?.label_value || "Stress Index",
          value: data.stress?.stress_index,
          avg: data.stress?.stress_index_avg,
          normal: data.stress?.stress_index_normal,
          status: data.stress?.stress_index_status,
        },
        {
          key: "normalized_stress_index",
          label:
            screenLabels?.normalized_stress_index_comment?.label_value ||
            "Normalized Stress Index",
          value: data.stress?.normalized_stress_index,
          avg: data.stress?.normalized_stress_index_avg,
          normal: data.stress?.normalized_stress_index_normal,
          status: data.stress?.normalized_stress_index_status,
        },
        {
          key: "mean_rri",
          label: screenLabels?.mean_rri_comment?.label_value || "Mean RRI",
          value: data.stress?.mean_rri,
          avg: data.stress?.mean_rri_avg,
          normal: data.stress?.mean_rri_normal,
          status: data.stress?.mean_rri_status,
        },
        {
          key: "rmssd",
          label: screenLabels?.rmssd?.label_value || "Rmssd",
          value: data.stress?.rmssd,
          avg: data.stress?.rmssd_avg,
          normal: data.stress?.rmssd_normal,
          status: data.stress?.rmssd_status,
        },
        {
          key: "recovery_ability_pns_zone",
          label:
            screenLabels?.recovery_ability_pns_zone_comment?.label_value ||
            "Recovery Ability (PNS zone)",
          value: data.stress?.recovery_ability_pns_zone,
          avg: data.stress?.recovery_ability_pns_zone_avg,
          normal: data.stress?.recovery_ability_pns_zone_normal,
          status: data.stress?.recovery_ability_pns_zone_status,
        },
        {
          key: "pns_index",
          label: screenLabels?.pns_index?.label_value || "PNS Index",
          value: data.stress?.pns_index,
          avg: data.stress?.pns_index_avg,
          normal: data.stress?.pns_index_normal,
          status: data.stress?.pns_index_status,
        },
        {
          key: "stress_response_sns_zone",
          label:
            screenLabels?.stress_response_sns_zone_comment?.label_value ||
            "Stress Response (SNS zone)",
          value: data.stress?.stress_response_sns_zone,
          avg: data.stress?.stress_response_sns_zone_avg,
          normal: data.stress?.stress_response_sns_zone_normal,
          status: data.stress?.stress_response_sns_zone_status,
        },
        {
          key: "sns_index",
          label: screenLabels?.sns_index?.label_value || "SNS Index",
          value: data.stress?.sns_index,
          avg: data.stress?.sns_index_avg,
          normal: data.stress?.sns_index_normal,
          status: data.stress?.sns_index_status,
        },
        {
          key: "sd1",
          label: screenLabels?.sd1_comment?.label_value || "SD 1",
          value: data.stress?.sd1,
          avg: data.stress?.sd1_avg,
          normal: data.stress?.sd1_normal,
          status: data.stress?.sd1_status,
        },
        {
          key: "sd2",
          label: screenLabels?.sd2_comment?.label_value || "SD 2",
          value: data.stress?.sd2,
          avg: data.stress?.sd2_avg,
          normal: data.stress?.sd2_normal,
          status: data.stress?.sd2_status,
        },
        {
          key: "lf_hf",
          label: screenLabels?.lf_hf_comment?.label_value || "LF/HF Ratio",
          value: data.stress?.lf_hf,
          avg: data.stress?.lf_hf_avg,
          normal: data.stress?.lf_hf_normal,
          status: data.stress?.lf_hf_status,
        },
      ],
    },
    {
      category: "Heart Health",
      metrics: [
        {
          key: "blood_pressure",
          label:
            screenLabels?.blood_pressure_comment?.label_value ||
            "Blood Pressure",
          value: data.heart_health?.blood_pressure,
          avg: data.heart_health?.blood_pressure_avg,
          normal: data.heart_health?.blood_pressure_normal,
          status: data.heart_health?.blood_pressure_status,
        },
        {
          key: "heart_rate",
          label: screenLabels?.heart_rate?.label_value || "Heart Rate",
          value: data.heart_health?.heart_rate,
          avg: data.heart_health?.heart_rate_avg,
          normal: data.heart_health?.heart_rate_normal,
          status: data.heart_health?.heart_rate_normal,
        },
        {
          key: "breating_rate",
          label:
            screenLabels?.breating_rate_comment?.label_value ||
            "Breathing Rate",
          value: data.heart_health?.breathing_rate,
          avg: data.heart_health?.breathing_rate_avg,
          normal: data.heart_health?.breathing_rate_normal,
          status: data.heart_health?.breathing_rate_normal,
        },
        {
          key: "oxygen_saturation",
          label:
            screenLabels?.oxygen_saturation_comment?.label_value ||
            "Oxygen Saturation",
          value: data.heart_health?.oxygen_saturation,
          avg: data.heart_health?.oxygen_saturation_avg,
          normal: data.heart_health?.oxygen_saturation_normal,
          status: data.heart_health?.oxygen_saturation_status,
        },
        {
          key: "hrv_sdnn",
          label: screenLabels?.hrv_sdnn_comment?.label_value || "HRV SDNN",
          value: data.heart_health?.hrv_sdnn,
          avg: data.heart_health?.hrv_sdnn_avg,
          normal: data.heart_health?.hrv_sdnn_normal,
          status: data.heart_health?.hrv_sdnn_status,
        },
        {
          key: "pulse_rate_quotient",
          label:
            screenLabels?.pulse_rate_quotient_comment?.label_value ||
            "Pulse Rate Quotient (PRQ)",
          value: data.heart_health?.pulse_rate_quotient,
          avg: data.heart_health?.pulse_rate_quotient_avg,
          normal: data.heart_health?.pulse_rate_quotient_normal,
          status: data.heart_health?.pulse_rate_quotient_status,
        },
        {
          key: "pulse_rate",
          label: screenLabels?.pulse_rate_comment?.label_value || "Pulse Rate",
          value: data.heart_health?.pulse_rate,
          avg: data.heart_health?.pulse_rate_avg,
          normal: data.heart_health?.pulse_rate_normal,
          status: data.heart_health?.pulse_rate_status,
        },
        {
          key: "heart_age",
          label: screenLabels?.heart_age_comment?.label_value || "Heart Age",
          value: data.heart_health?.heart_age,
          avg: data.heart_health?.heart_age_avg,
          normal: data.heart_health?.heart_age_normal,
          status: data.heart_health?.heart_age_status,
          cronologicalAge: data.heart_health?.chronological_age
            ? `${data.heart_health?.chronological_age} years`
            : "-",
        },
        {
          key: "vo2_max",
          label: screenLabels?.vo2_max_comment?.label_value || "VO2Max",
          value: data.heart_health?.vo2_max,
          avg: data.heart_health?.vo2_max_avg,
          normal: data.heart_health?.vo2_max_normal,
          status: data.heart_health?.vo2_max_status,
        },
        {
          key: "mean_arterial_pressure",
          label:
            screenLabels?.mean_arterial_pressure_comment?.label_value ||
            "Mean Arterial Pressure",
          value: data.heart_health?.mean_arterial_pressure,
          avg: data.heart_health?.mean_arterial_pressure_avg,
          normal: data.heart_health?.mean_arterial_pressure_normal,
        },
        {
          key: "cardiac_workload",
          label:
            screenLabels?.cardiac_workload_comment?.label_value ||
            "Cardiac Workload",
          value: data.heart_health?.cardiac_workload,
          avg: data.heart_health?.cardiac_workload_avg,
          normal: data.heart_health?.cardiac_workload_normal,
        },
        {
          key: "pulse_pressure",
          label:
            screenLabels?.pulse_pressure_comment?.label_value ||
            "Pulse Pressure",
          value: data.heart_health?.pulse_pressure,
          avg: data.heart_health?.pulse_pressure_avg,
          normal: data.heart_health?.pulse_pressure_normal,
        },
      ],
    },
  ];
};

export const formatBiomarkerName = (key, screenLabels) => {
  if (!key) return "";

  const formattedKey = key.toLowerCase().replace(/\s+/g, "_");

  if (screenLabels?.[`${formattedKey}`]?.label_value) {
    return screenLabels[formattedKey].label_value;
  }

  return key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
};
